import { useState } from "react";
import { TextField, FormControl } from "@mui/material";
import { useFormik } from "formik";
import Yup from "validation/Validation";
import { useResponseErrorOnly } from "hooks";
import { CategoriesSelect, GridFilter } from "components";
import { useGetCategoriesQuery } from "redux/api/slices/server";

const SearchBar = ({ Arama, data }) => {
  const [urunKategori, setUrunKategori] = useState(0);
  const categories = useGetCategoriesQuery();

  const handleOnChange = (e) => {
    setUrunKategori(e.target.value);
  };

  const formFields = {
    makale: Yup.string(),
  };

  const validationSchema = Yup.object(formFields);
  const formikConfig = {
    initialValues: {
      makale: "",
      urunKategori: urunKategori,
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      resetForm();
      Arama({
        title: values.makale,
        categoryId: parseInt(urunKategori),
      });
    },
  };

  const { handleSubmit, handleChange, values, errors, resetForm } =
    useFormik(formikConfig);

  useResponseErrorOnly(data);

  return (
    <GridFilter
      data={data}
      newItemUrl="/detail-article/0"
      handleSubmit={handleSubmit}
      title={"Makale Arama"}
    >
      <div className="grid grid-cols-2 gap-3 mb-4">
        <FormControl fullWidth sx={{ m: 0 }}>
          <TextField
            sx={{ m: 0 }}
            size="small"
            margin="normal"
            required
            fullWidth
            id="makale"
            label="Makale"
            name="makale"
            autoComplete="makale"
            onChange={handleChange}
            values={values.makale}
            helperText={errors.makale && errors.makale}
            error={errors.makale ? true : false}
          />
        </FormControl>
        <FormControl fullWidth sx={{ mt: 0 }}>
          <CategoriesSelect
            data={categories}
            urunKategori={urunKategori}
            handleOnChange={handleOnChange}
            defaultTitle="Kategori Seçin"
          />
        </FormControl>
      </div>
    </GridFilter>
  );
};

export default SearchBar;
